import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const mailing = {

  namespaced: true,

  state: {
    mailing: {},
    deliveries: {},
  },

  getters: {
    mailing: state => state.mailing,
    deliveries: state => state.deliveries,
  },

  mutations: {
    setMailing(state, mailing) { state.mailing = mailing },
    setPublish(state, publish) { state.mailing.publish = publish },
    setDeliveries(state, deliveries) { state.deliveries = deliveries },
  },

  actions: {

    async getMailing({ commit }) { 
      const mailing = await Vue.axios.get(API_URL + '/mailings/' + router.currentRoute.params.id)
      commit('setMailing', mailing.data);
    },

    async getDeliveries({ commit }) {
      const response = await Vue.axios.get(API_URL + '/mailings/' + router.currentRoute.params.id + '/deliveries')
      const deliveries = {};
      let number = 1;
      response.data.map(delivery => {
        delivery.number = number;
        delivery.mails = [];
        delivery.show = false;
        deliveries['delivery_' + delivery.id] = delivery;
        number++;
      })
      commit('setDeliveries', deliveries);
    },

  }
}
